import React from 'react';

import {
  Pressable,
  View
} from 'react-native';

import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as ht from './_ht';
import * as cr from './_cr';

import * as gs from './_csGbl';

import * as cmODT from './_cmODT';

import * as ica from 'src/ica';

import { a } from './_csAbt';

const _BoxC = React.memo((pz: ht.boxCz) => {

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.boxAbtz[_abtType] ? ica.boxAbtz[_abtType]() : {};

  let _o = (
    cr.c(View, {
      key: 'Box.root',
      ... _abtz.boxPtyz,
      ... pz.boxPtyz,
      style: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
    }, 
      pz.oClds
    )
  );

  if (hf.f(pz.pslPtyz)) {
    _o = (
      cr.c(Pressable, { // 別途 dw を指定用
        key: 'Psl.root',        
        ...pz.pslPtyz,
        onPress: 
          pz.pslPtyz?.onPress ?
          async () => {
/*
            const _gUserz = gs.useUserz();
            await _gUserz.saveAsync({ // wait しない, onPress のみ対象
              ornDtm: hfDTM.getNow()
            });
*/
            await cmODT.setAsync();
            pz.pslPtyz?.onPress();
          }
          : undefined,
      }, 
        _o
      )
    );
  }
  return _o;
});

export const N = _BoxC;

export const V = React.memo((pz: ht.boxCz) => {
  return (
    cr.c(_BoxC, {
      key: -10,
      ...pz,
      boxStlz: {
        'box-sizing': 'border-box',
        ... pz.boxStlz,
        ... a('fd/css')
      }
    })
  )
});

export const H = React.memo((pz: ht.boxCz) => {
  return (
    cr.c(_BoxC, {
      key: -10,
      ...pz,
      boxStlz: {
        ... pz.boxStlz,
        ... a('fd/rss')
      }
    })
  )
});

export const S = React.memo((pz: ht.boxCz) => {
  return (
    cr.c(_BoxC, {
      key: -10,
      ...pz,
      boxStlz: {
        ... a('f/1'),
        ... pz.boxStlz,
      }
    })
  )
});
